import * as service from './service'
export default {
  namespace: 'recommendMessengerFriendDetail',
  state: {
    detailData: {
      courierPhoneNum: '',
      activity: {},
      awardList: [{}],
      courierStatusContent: ''
    }
  },
  effects: {
    * friendDetail ({ payload }, { call, put }) {
      const res = yield call(service.friendDetail, payload)
      yield put({
        type: 'save',
        payload: {
          detailData: res.data.data
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
